import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';

class SearchCommonDataEnterprise extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { benefits_id, operator_name, province_id, status } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">               
                        <Row className="mt-3">
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{benefits_id.label}</InputGroup.Text>
                                        <CommonSelect
                                            element="Searchs"
                                            input={benefits_id}
                                            option={{source: 'db', data: Masterbase?.benefits}}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)}
                                        />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{province_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={province_id}
                                        option={{source: 'db', data: Masterbase?.province}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)}
                                    />
                                </InputGroup>
                            </Col>  
                            <Col md={3}></Col>               
                        </Row>
                        <Row> 
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{operator_name.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={operator_name}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={!['0', '1', '5'].includes(UserCookie.types)}
                                    />
                                </InputGroup>
                            </Col>                
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={status}
                                        option={{source: 'options', section: 'status', item: 'default'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                            <Col md={3}></Col>  
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchCommonDataEnterprise;